import React from "react";
import "./Industrie.css";
import indus from "./IMG/Indus.svg";
import Small from "./IMG/SM.svg";

function Industrie() {
  return (
    <>
      <h2 className="JG9618">Industries we support</h2>
      <p className="industry-intro">Role requirements vary across sectors. We use the actual job duties, essential skills and working conditions to define the recruitment brief for each engagement.</p>
      <div className="Vajhsf962">
        <img className="Ffg963854tr" src={indus} alt="" />
        <img className="Small-Img" src={Small} alt="" />
      </div>
    </>
  );
}

export default Industrie;
